// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Login Page Styles
 * Styles for the authentication/login page
 */

/* Page Container */
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--color-slate-900) 0%, var(--color-slate-800) 50%, var(--color-slate-900) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-container {
  max-width: 28rem;
  width: 100%;
}

/* Logo Section */
.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.login-logo {
  width: 5rem;
  height: 5rem;
  border-radius: var(--radius-xl);
  object-fit: contain;
}

.login-subtitle {
  color: var(--color-gray-400);
  font-size: var(--font-size-sm);
}

/* Login Card */
.login-card {
  background-color: #ffffff;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  padding: 2rem;
}

.dark .login-card {
  background-color: var(--color-slate-800);
}

.login-card__title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 1.5rem;
}

/* Error Alert */
.login-error {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: var(--radius-lg);
}

.dark .login-error {
  background-color: rgba(220, 38, 38, 0.2);
  border-color: #991b1b;
}

.login-error__content {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: var(--font-size-sm);
  color: #991b1b;
}

.dark .login-error__content {
  color: #fca5a5;
}

.login-error__icon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

/* Login Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.login-form__field {
  display: flex;
  flex-direction: column;
}

.login-form__label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-700);
  margin-bottom: 0.5rem;
}

.dark .login-form__label {
  color: var(--color-gray-300);
}

.login-form__input-wrapper {
  position: relative;
}

.login-form__input {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: var(--font-size-base);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--radius-md);
  background-color: #ffffff;
  color: var(--color-text-primary);
  transition: var(--transition-fast);
}

.dark .login-form__input {
  background-color: var(--color-slate-900);
  border-color: var(--color-slate-600);
}

.login-form__input:focus {
  outline: none;
  border-color: var(--color-primary-500);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.login-form__input--with-icon {
  padding-right: 2.75rem;
}

.login-form__input--error {
  border-color: var(--color-danger-500);
}

.login-form__input--error:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.login-form__icon-btn {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--color-gray-400);
  cursor: pointer;
  padding: 0.25rem;
  transition: var(--transition-fast);
}

.login-form__icon-btn:hover {
  color: var(--color-gray-600);
}

.dark .login-form__icon-btn:hover {
  color: var(--color-gray-300);
}

.login-form__icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* Submit Button */
.login-submit-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: var(--color-primary-600);
  color: #ffffff;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: var(--transition-base);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.login-submit-btn:hover:not(:disabled) {
  background-color: var(--color-primary-700);
}

.login-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-submit-btn__spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Help Text */
.login-help {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-gray-200);
}

.dark .login-help {
  border-top-color: var(--color-slate-700);
}

.login-help__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.login-help__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.login-help__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.login-help__credential {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.login-help__email {
  font-family: 'Courier New', monospace;
  color: var(--color-text-primary);
}

.login-help__password {
  font-family: 'Courier New', monospace;
  color: var(--color-gray-500);
}

.login-help__role {
  padding: 0.125rem 0.5rem;
  background-color: var(--color-primary-100);
  color: var(--color-primary-700);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
}

.dark .login-help__role {
  background-color: rgba(37, 99, 235, 0.2);
  color: var(--color-primary-400);
}

/* Demo Credentials Info Banner */
.login-info-banner {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: var(--color-blue-50);
  border: 1px solid var(--color-blue-200);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.dark .login-info-banner {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.2);
}

.login-info-banner__icon {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-blue-600);
}

.dark .login-info-banner__icon {
  color: var(--color-blue-400);
}

.login-info-banner__content {
  flex: 1 1;
}

.login-info-banner__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-blue-700);
  margin-bottom: 0.25rem;
}

.dark .login-info-banner__title {
  color: var(--color-blue-400);
}

.login-info-banner__text {
  font-size: var(--font-size-xs);
  color: var(--color-blue-600);
}

.dark .login-info-banner__text {
  color: var(--color-blue-300);
}

/* Footer Text */
.login-footer {
  margin-top: 2rem;
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
}

.dark .login-footer {
  color: var(--color-gray-400);
}

`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mBAAmB;AACnB;EACE,iBAAiB;EACjB,uHAAuH;EACvH,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;EACd,gCAAgC;EAChC,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/**\n * Login Page Styles\n * Styles for the authentication/login page\n */\n\n/* Page Container */\n.login-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--color-slate-900) 0%, var(--color-slate-800) 50%, var(--color-slate-900) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.login-container {\n  max-width: 28rem;\n  width: 100%;\n}\n\n/* Logo Section */\n.login-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.login-logo-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.login-logo {\n  width: 5rem;\n  height: 5rem;\n  border-radius: var(--radius-xl);\n  object-fit: contain;\n}\n\n.login-subtitle {\n  color: var(--color-gray-400);\n  font-size: var(--font-size-sm);\n}\n\n/* Login Card */\n.login-card {\n  background-color: #ffffff;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  padding: 2rem;\n}\n\n.dark .login-card {\n  background-color: var(--color-slate-800);\n}\n\n.login-card__title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: 1.5rem;\n}\n\n/* Error Alert */\n.login-error {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: var(--radius-lg);\n}\n\n.dark .login-error {\n  background-color: rgba(220, 38, 38, 0.2);\n  border-color: #991b1b;\n}\n\n.login-error__content {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: var(--font-size-sm);\n  color: #991b1b;\n}\n\n.dark .login-error__content {\n  color: #fca5a5;\n}\n\n.login-error__icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n/* Login Form */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.login-form__field {\n  display: flex;\n  flex-direction: column;\n}\n\n.login-form__label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-gray-700);\n  margin-bottom: 0.5rem;\n}\n\n.dark .login-form__label {\n  color: var(--color-gray-300);\n}\n\n.login-form__input-wrapper {\n  position: relative;\n}\n\n.login-form__input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: var(--font-size-base);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--radius-md);\n  background-color: #ffffff;\n  color: var(--color-text-primary);\n  transition: var(--transition-fast);\n}\n\n.dark .login-form__input {\n  background-color: var(--color-slate-900);\n  border-color: var(--color-slate-600);\n}\n\n.login-form__input:focus {\n  outline: none;\n  border-color: var(--color-primary-500);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.login-form__input--with-icon {\n  padding-right: 2.75rem;\n}\n\n.login-form__input--error {\n  border-color: var(--color-danger-500);\n}\n\n.login-form__input--error:focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.login-form__icon-btn {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--color-gray-400);\n  cursor: pointer;\n  padding: 0.25rem;\n  transition: var(--transition-fast);\n}\n\n.login-form__icon-btn:hover {\n  color: var(--color-gray-600);\n}\n\n.dark .login-form__icon-btn:hover {\n  color: var(--color-gray-300);\n}\n\n.login-form__icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Submit Button */\n.login-submit-btn {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background-color: var(--color-primary-600);\n  color: #ffffff;\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  border: none;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: var(--transition-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.login-submit-btn:hover:not(:disabled) {\n  background-color: var(--color-primary-700);\n}\n\n.login-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-submit-btn__spinner {\n  width: 1.25rem;\n  height: 1.25rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Help Text */\n.login-help {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-gray-200);\n}\n\n.dark .login-help {\n  border-top-color: var(--color-slate-700);\n}\n\n.login-help__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.login-help__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.login-help__item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.login-help__credential {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.login-help__email {\n  font-family: 'Courier New', monospace;\n  color: var(--color-text-primary);\n}\n\n.login-help__password {\n  font-family: 'Courier New', monospace;\n  color: var(--color-gray-500);\n}\n\n.login-help__role {\n  padding: 0.125rem 0.5rem;\n  background-color: var(--color-primary-100);\n  color: var(--color-primary-700);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n}\n\n.dark .login-help__role {\n  background-color: rgba(37, 99, 235, 0.2);\n  color: var(--color-primary-400);\n}\n\n/* Demo Credentials Info Banner */\n.login-info-banner {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: var(--color-blue-50);\n  border: 1px solid var(--color-blue-200);\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.dark .login-info-banner {\n  background-color: rgba(59, 130, 246, 0.1);\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.login-info-banner__icon {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--color-blue-600);\n}\n\n.dark .login-info-banner__icon {\n  color: var(--color-blue-400);\n}\n\n.login-info-banner__content {\n  flex: 1;\n}\n\n.login-info-banner__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-blue-700);\n  margin-bottom: 0.25rem;\n}\n\n.dark .login-info-banner__title {\n  color: var(--color-blue-400);\n}\n\n.login-info-banner__text {\n  font-size: var(--font-size-xs);\n  color: var(--color-blue-600);\n}\n\n.dark .login-info-banner__text {\n  color: var(--color-blue-300);\n}\n\n/* Footer Text */\n.login-footer {\n  margin-top: 2rem;\n  text-align: center;\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-500);\n}\n\n.dark .login-footer {\n  color: var(--color-gray-400);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
